<template>
  <b-alert
    v-height-fade.appear
    variant="danger"
    dismissible
    fade
    :show="errorShow"
    class="mb-1"
    @dismissed="errorShow = false"
  >
    <div class="alert-body">
      <span>{{ error.message }} </span>
      <span v-if="error.code === 'emailNotVerified'">
        <a
          :style="{fontWeight:'bold'}"
          @click="resendEmailVerification"
        >{{ $t('click') }}</a> {{ $t('to resend') }}
      </span>
    </div>
  </b-alert>
</template>

<script>
/* eslint-disable global-require */
import { BAlert } from 'bootstrap-vue'
import { heightFade } from '@core/directives/animations'
import store from '@/store'

export default {
  name: 'ErrorAlert',
  components: {
    BAlert,
  },
  directives: {
    heightFade,
  },
  props: {
    error: {
      type: Object,
      default() {
        return {
          code: '',
          message: '',
        }
      },
    },
    errorShow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    resendEmailVerification() {
      store.dispatch('resendEmailVerification', this.loginFrom)
    },
  },
}
</script>
